import { Col, Row, Pagination as BootstrapPagination } from "react-bootstrap"
import styles from './Pagination.module.css'
import { useContext } from "react"
import { Context as PaginationContext } from "../../contexts/PaginationContext"

interface paginationPropsInterface {
    maxPages: number
    currentPage: number
    recordsPerPageProps: string
    recordsPerPage: number
    modifyPage: (page: number) => void
    modifyRecordsPerPage: (rpp: number) => void
}

export default function Pagination(props: paginationPropsInterface) {
    const { maxPages, currentPage, recordsPerPageProps, recordsPerPage, modifyPage, modifyRecordsPerPage } = props
    const { recordsPerPageList } = useContext(PaginationContext)
    
    const paginationButtons = 7 // Indicate the numbers of the pagination with numbers
    const middle = parseInt(Math.floor(paginationButtons / 2).toString())

    const paginationNumbers: number[] = []

    if(currentPage > 1) {
        for(let i = 0; i < middle; i++) {
            const n = currentPage - (middle - i)
            if(n > 0) {
                paginationNumbers.push(n)
            }
        }
    }

    paginationNumbers.push(currentPage)

    if(currentPage < maxPages) {
        for(let i = 0; i < middle; i++) {
            const n = currentPage + i + 1
            if(n <= maxPages) {
                paginationNumbers.push(n)
            }
        }
    }

    let length = paginationNumbers.length
    let hasPrev = paginationNumbers[0] > 1
    let hasNext = paginationNumbers[length - 1] < maxPages
    let canPush = length < paginationButtons && (hasPrev || hasNext)
    while(canPush) {
        if(hasPrev) {
            const prev = paginationNumbers[0] - 1
            paginationNumbers.unshift(prev)

            length++

            hasPrev = prev > 1
            canPush = length < paginationButtons && (hasPrev || hasNext)
        }

        if(canPush && hasNext) {
            const next = paginationNumbers[length - 1] + 1
            paginationNumbers.push(next)

            length++

            hasNext = paginationNumbers[length - 1] < maxPages
            canPush = length < paginationButtons && (hasPrev || hasNext)
        }
    }

    hasPrev = paginationNumbers[0] > 1
    hasNext = paginationNumbers[length - 1] < maxPages

    return (
        <Row className="w-100 justify-content-center align-items-center">
            <Col sm="5">
                <BootstrapPagination className="m-auto">
                    <BootstrapPagination.First
                        className={ styles.paginationButton }
                        disabled={ currentPage === 1}
                        onClick={e => {
                            e.preventDefault()
                            modifyPage(1)
                        }}
                    />
                    
                    <BootstrapPagination.Prev
                        className={ styles.paginationButton }
                        disabled={ currentPage === 1}
                        onClick={e => {
                            e.preventDefault()
                            modifyPage(currentPage - 1)
                        }}
                    />

                    {
                        paginationNumbers.map(i => {
                            const active = currentPage === i
                            return (
                                <BootstrapPagination.Item
                                    key={ `pagination-button-${i}` }
                                    className={ styles.paginationButton }
                                    disabled={ active }
                                    active={ active }
                                    onClick={e => {
                                        e.preventDefault()
                                        modifyPage(i)
                                    }}
                                >
                                    {i}
                                </BootstrapPagination.Item>
                            )
                        })
                    }

                    <BootstrapPagination.Next
                        className={ styles.paginationButton }
                        disabled={ currentPage === maxPages }
                        onClick={e => {
                            e.preventDefault()
                            modifyPage(currentPage + 1)
                        }}
                    />

                    <BootstrapPagination.Last
                        className={ styles.paginationButton }
                        disabled={ currentPage === maxPages }
                        onClick={e => {
                            e.preventDefault()
                            modifyPage(maxPages)
                        }}
                    />
                </BootstrapPagination>
            </Col>

            <Col sm="4" className="text-end">
                { recordsPerPageProps }
            </Col>

            <Col sm="3" style={{justifyItems: "end"}}>
                <BootstrapPagination className="mt-auto mb-auto" style={{marginRight:"0px"}}>
                    {
                        recordsPerPageList.map(i => {
                            const active = recordsPerPage === i
                            return (
                                <BootstrapPagination.Item
                                    key={ `records-per-page-list-${i}` }
                                    className={ styles.paginationButton }
                                    active={ active }
                                    disabled={ active }
                                    onClick={e => {
                                        e.preventDefault()
                                        modifyRecordsPerPage(i)
                                    }}
                                >
                                    {i}
                                </BootstrapPagination.Item>
                            )
                        })
                    }
                </BootstrapPagination>
            </Col>
        </Row>
    )
}